import { WSSelectOption } from "@wingspanhq/fe-component-library";
import { AccountingCustomer } from "@wingspanhq/wingspan-api-sdk";
import sortBy from "lodash/sortBy";
import { selectorAccountingCustomerLabel } from "./selectorAccountingCustomerLabel";

/**
 * QuickBooks customers as `WSSelect` options, sorted by label. The v3
 * counterpart of `selectQuickbooksUserOptions`; the option value is the
 * reference id the mapping write stores.
 */
export const selectorAccountingCustomerOptions = (
  customers?: AccountingCustomer[]
): WSSelectOption[] =>
  sortBy(
    (customers || []).map(customer => ({
      label: selectorAccountingCustomerLabel(customer),
      value: customer.id,
      searchText: [customer.displayName, customer.companyName, customer.email]
        .filter(Boolean)
        .join(" ")
    })),
    option => option.label.toLocaleLowerCase()
  );
